import {isRailway} from '../../../../../../../lib/travels/operation-type.js'
import ProductDataMixin from '../../../_product-data.js'

import template from './index.pug'

const VALIDATION_TYPE_FLAT_RATE = 13

// @vue/component
export default {
  template: template(),

  mixins: [ProductDataMixin],

  props: {
    productTransactions: {
      type: Object,
      required: true
    },
    currentTab: {
      type: String
    }
  },
  computed: {
    date() {
      const date = moment(this.productTransactions.operation_date)

      return date.format('DD MMM HH:mm').replace('.', '')
    },

    travelTypeName() {
      switch (this.productTransactions.type) {
        case VALIDATION_TYPE_FLAT_RATE: return 'flatRate'
        default: return ''
      }
    },
    hasDestination() {
      return this.productTransactions.has_destination
    },
    stopsText() {
      if (this.hasDestination) { return this.stopFromStopToText }

      return this.stopText
    },
    stopFromStopToText() {
      const data = {
        stopFromName: this.productTransactions.stop ? this.productTransactions.stop.name : '',
        stopToName: this.productTransactions.stop_to ? this.productTransactions.stop_to.name : ''
      }
      if (Object.values(data).join().trim() === ',') return ''

      return this.$t('balance.stops.originDestination', data)
    },
    stopText() {
      const stopName = this.productTransactions.stop ? this.productTransactions.stop.name : ''

      return this.$t('balance.stops.onlyOrigin', {stopName})
    },

    travelTypeIcon() {
      switch (this.productTransactions.type) {
        case VALIDATION_TYPE_FLAT_RATE: return 'ns-icon-ticket text-gray2'
        default: return ''
      }
    },

    showTripWordsAmount() {
      if (this.productTransactions.amount > 1) {
        return this.$t('balance.transaction.travels')
      }

      return this.$t('balance.transaction.travel')
    },

    showTripWordsBalance() {
      if (this.productTransactions.balance_before > 1) {
        return this.$t('balance.transaction.travels')
      }

      return this.$t('balance.transaction.travel')
    },

    isRailway() {
      return isRailway(this.productTransactions.tipo_operacion)
    }

  },
  methods: {
    calculateColor(productTransactions) {
      if (productTransactions && productTransactions.route && productTransactions.route.color) {
        return `--bg-pill: ${productTransactions.route.color}`
      }

      return ''
    }
  }
}
